export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20discovery%20concept%20with%20neatly%20arranged%20fashion%20pieces%20on%20light%20oak%20wooden%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20cream%20color%20palette%2C%20clean%20composition%2C%20premium%20editorial%20photography%2C%20airy%20positive%20vibe%2C%20modern%20european%20aesthetic&width=1800&height=900&seq=kakobuy-hero-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs md:text-sm mb-6">
            <i className="ri-sparkling-line"></i>
            <span>Aktualizacja 2026 – Największa baza produktów</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Kakobuy Spreadsheet Polska
            <br />
            <span className="text-accent-300">Twoja baza najlepszych produktów z Chin</span>
          </h1>

          <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Odkrywaj tysiące sprawdzonych produktów dzięki Kakobuy Spreadsheet. Porównuj ceny, sprawdzaj opinie, przeglądaj zdjęcia QC i kupuj bezpieczniej niż kiedykolwiek wcześniej.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-full text-sm md:text-base transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-accent-500/25"
            >
              <i className="ri-shopping-cart-2-line text-lg"></i>
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-full text-sm md:text-base transition-all cursor-pointer whitespace-nowrap border border-white/25"
            >
              <i className="ri-flashlight-line text-lg"></i>
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-white/70 text-xs">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Aktualizowana baza
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Poradnik dla Polski
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Instrukcje bezpieczeństwa
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Lista kategorii
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}